module.exports.default = {
    "ORDER": "Ordine",
    "SCHEDULE.YOU_ARE_ALL_SET": "È tutto pronto!",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "La consegna è prevista per",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Salve #, si prega di programmare la consegna",
    "SCHEDULE.SCHEDULE_NOW": "Pianifica ora",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Consegna e aggiornamenti di stato",
    "SCHEDULE.EMAIL_UPDATES": "Aggiornamenti via e-mail",
    "SCHEDULE.SMS_UPDATES": "Aggiornamenti via SMS",
    "SCHEDULE.DISABLE_UPDATES": "Non desidero ricevere aggiornamenti.",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Desidero ricevere lo stato aggiornato sulla mia consegna nei seguenti canali:",
    "OOPS": "Oops!",
    "SOMETHING_WENT_WRONG": "Qualcosa è andato storto.",
    "REFRESH": "Aggiorna",
    "PAGE_NOT_FOUND": "Pagina non trovata",
    "COULD_NOT_FIND_PAGE": "Non siamo riusciti a trovare la pagina che cercavate.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Impossibile inviare un messaggio vuoto",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Inserisci il tuo messaggio all'autista",
    "TRACKING.SEND": "Invia",
    "TRACKING.ARRIVING_AT": "Arrivo in",
    "TRACKING.ETA": "Tempo stimato di arrivo",
    "TRACKING.MIN": "min",
    "TRACKING.MAP": "Mappa",
    "TRACKING.SATELLITE": "Satellite",
    "TRACKING.TERRAIN": "Terreno",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Ehi, sono arrivato!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "has arrived at",
    "COMPLETED": "Order was scheduled\n",
    "RATING.SKIP": "Salta",
    "RATING.WHAT_WENT_WELL": "Cosa è andato bene?",
    "RATING.WHAT_WENT_WRONG": "Cosa è andato storto?",
    "RATING.THANK_YOU": "Grazie",
    "RATING.FOR_USING_OUR_SERVICE": "Grazie per aver utilizzato il nostro servizio!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Com'è stata la vostra esperienza di consegna?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Aiutateci a migliorare valutando la vostra esperienza",
    "SCHEDULE.RATE_US": "Valutateci!",
    "TERM_OF_USE": "Termini di utilizzo",
    "PRIVACY_POLICY": "Informativa sulla privacy",
    "SHARING_MY_LOCATION": "Condividere la mia posizione",
    "SHARING_LOADING": "Condivisione del carico...",
    "REQUIRED_FIELD_MESSAGE": "Questo campo è obbligatorio",
    "CONTACT_NAME": "Contatto",
    "PHONE_NUMBER": "Numero di telefono",
    "EMAIL_ADDRESS": "Indirizzo E-Mail",
    "SEND": "Invia",
    "FORWARD.THIS_ORDER": "Inoltrare la consegna",
    "FORWARD.TO_CONTACT": "Inoltrare al contatto",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Siete sicuri di voler inoltrare questo ordine?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "vi ha inoltrato una consegna",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Siete sicuri di voler rifiutare questo ordine?",
    "ACCEPT": "Accetta",
    "REJECT": "Rifiuta",
    "PICKUP.SET_PICKUP_TIME": "Sono sulla mia strada",
    "PICKUP.IVE_ARRIVED": "",
    "PICKUP.PICKUP_ETA_SET_FAILED": "",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "",
    "PICKUP.MIN": "",
    "PICKUP.SHOW_THIS_NUMBER": "",
    "PICKUP.IM_OUTSIDE": "",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "",
    "PICKUP.I_WILL_ARRIVE_AT": "",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "",
    "PICKUP.IN": "",
    "PICKUP.TO": "",
    "PICKUP.COLLECT": "",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "",
    "PICKUP.CANCEL": "",
    "PICKUP.CONFIRM_TIME": "",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "Il conducente è attualmente ad una fermata di distanza da voi",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "fermate di distanza da voi",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "Il conducente è attualmente",
    "PICKUP.OK": "",
    "PICKUP.NEXT": "",
    "PICKUP.SKIP": "",
    "CAR_ARRIVED.TITLE": "",
    "CAR_ARRIVED.PARKING_SPOT": "",
    "CAR_ARRIVED.LICENSE_PLATE": "",
    "CAR_ARRIVED.VEHICLE_MODEL": "",
    "CAR_ARRIVED.VEHICLE_COLOR": "",
    "CAR_ARRIVED.REMEMBER": "",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "",
    "REDIRECT_PICKUP.TO": "",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "",
    "REDIRECT_PICKUP.FAILED_TITLE": "",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "",
    "REDIRECT_PICKUP.OK": "",
    "REDIRECT_PICKUP.KM": "",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "",
    "SOON": "Presto",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "",
    "GLOBAL.CALL": "",
    "GLOBAL.CANCEL": "",
    "﻿PICKUP.SET_PICKUP_TIME": "",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "",
    "SCHEDULED.THANKS_FOR_USING": "",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "",
    "Submit": "",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "",
    "PICKUP.SHOW_ID": "",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "",
    "OPEN_MENU": "",
    "CLOSE_MENU": "",
    "MAP_AUTO_CENTER": "",
    "MAP_SETTINGS": "",
    "ZOOM_OUT": "",
    "ZOOM_IN": "",
    "TRACKING.CALL_DRIVER": "Chiamare l'autista",
    "TRACKING.MESSAGE_DRIVER": "Messaggio il driver",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "",
    "SCHEDULE.TIME_ZONE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "",
    "TRACKING.THANKS_MESSAGE_TEXT": "",
    "TRACKING.THANKS_MESSAGE_TITLE": "",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "",
    "CANCEL_ORDER": "",
    "CANCELLATION_VALIDATION_TITLE": "",
    "CANCELLATION_VALIDATION_BACK": "",
    "CANCELLATION_VALIDATION_YES": "",
    "CANCEL_SUCCESS": "",
    "CANCEL_PAST_ALLOWED": "",
    "CANCEL_ERROR": "",
    "RATING.FREE_TEXT_COMMENT": "Dicci di più",
    "RATING.ORDER_DELIVERED_GREEN": "Abbiamo consegnato il tuo ordine con un veicolo ecologico",
    "CX_ORDER_STATUS.CONFIRMED": "Ordine confermato. Ci siamo su di esso.",
    "CX_ORDER_STATUS.RECEIVED": "Ordine Ricevuto. Saremo in contatto a breve.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Stiamo trovando un driver per il tuo ordine.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Abbiamo trovato il driver per il tuo ordine.",
    "CX_ORDER_STATUS.PICKING_UP": "Stiamo raccogliendo il tuo ordine in questo momento.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Siamo sulla buona strada per prendere il tuo ordine.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Stiamo completando una consegna precedente prima del tuo ordine.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "Il tuo ordine è in arrivo ora!",
    "CX_ORDER_STATUS.ARRIVED": "Il tuo ordine è arrivato!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Stato della consegna",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Mostra lo stato della consegna ai clienti",
    "CONFIRM": "Confermare",
    "FLOW_OPTIONS.TITLE": "Come vuoi raccogliere il tuo ordine?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Consegnato alla tua auto in un punto designato",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Marciapiede",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Pickup in negozio o in una posizione impostata",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Fare clic e raccogliere",
    "RATING_STAR_ALT": "",
    "RATING_STAR_ALT_ONE": "L'orario di arrivo stimato è di",
    "RATING_STAR_ALT_TWO": "stelle",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "L'orario di arrivo stimato è di",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Mappa per tracciare l'ordine",
    "SCHEDULE.EXTERNAL_ID_INFO": "",
    "SCHEDULE.TASK_NOTE_LABEL": ""
};
	